import { render } from "./TemplateSelector.vue?vue&type=template&id=5b0f5d3e&scoped=true"
import script from "./TemplateSelector.vue?vue&type=script&lang=ts"
export * from "./TemplateSelector.vue?vue&type=script&lang=ts"

import "./TemplateSelector.vue?vue&type=style&index=0&id=5b0f5d3e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5b0f5d3e"

export default script